import { memo } from 'react';
import { cn } from '@divlab/divanui';

import Img from '@UI/Img';
import Link from '@UI/Link';
import styles from './MainGallery.module.css';

import type { InteractiveMenuData } from '@Pages/PageWikiMain/typings';
import type { FC, HTMLAttributes } from 'react';

export interface MainGalleryProp extends HTMLAttributes<HTMLDivElement> {
  className?: string;
  mainGallery: InteractiveMenuData;
}

const MainGallery: FC<MainGalleryProp> = (props) => {
  const { className, mainGallery, ...restProps } = props;
  const { main, other } = mainGallery;

  return (
    <div {...restProps} className={cn(styles.mainGallery, className)}>
      <div className={styles.wrapper}>
        {main.map((item) => (
          <Link to={item.link} className={styles.categoryItem} key={item.link}>
            <Img
              src={item.image}
              className={styles.bigPoster}
              cnImage={styles.cnImage}
              loading='eager'
            />
            <div className={styles.title}>{item.title}</div>
            <div className={styles.info}>{item.description}</div>
          </Link>
        ))}
      </div>

      <div className={styles.wrapper}>
        {other.map((item) => (
          <Link to={item.link} className={styles.subCategoryItem} key={item.link}>
            <div className={styles.smallPosterWrapper}>
              <Img src={item.image} className={styles.smallPoster} />
              <div className={styles.toner} />
            </div>
            <div className={styles.subTitle}>{item.title}</div>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default memo(MainGallery);
